package devxertech.com.section

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaPhone
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.CommonButton
import devxertech.com.component.CommonText
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event

@Composable
fun SideBar(breakpoint: Breakpoint, showExtraText: Boolean = false, onClose: () -> Unit) {
    val sitePalette = ColorMode.current.toSitePalette()
    val ctx = rememberPageContext()
    var isServicesDropdownOpen by remember { mutableStateOf(false) }
    var isIndustriesDropdownOpen by remember { mutableStateOf(false) }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = { event ->
            val target = event.target as? HTMLElement
            val sidebar = document.getElementById("sidebar-container")
            if (sidebar != null && target != null && !sidebar.contains(target)) {
                onClose()
            }
        }

        document.addEventListener("click", listener)
        onDispose {
            document.removeEventListener("click", listener)
        }
    }

    Column(
        modifier = Modifier.fillMaxSize()
            .overflow(overflowX = Overflow.Hidden, overflowY = Overflow.Auto)
            .position(Position.Fixed)
            .zIndex(100)

    ) {
        Column(
            modifier = Modifier.width(if (breakpoint == Breakpoint.MD) 320.px else 280.px)
                .id("sidebar-container")
                .fillMaxHeight()
                .gap(15.px)
                .padding(leftRight = 25.px)
                .align(Alignment.End)
                .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb),
            horizontalAlignment = Alignment.Start,
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Image(src = Res.Image.dx_logo, modifier = Modifier.size(80.px).margin(left = (-5).px))
                BarsSotIcon(onClose = onClose)
//                FaBarsStaggered(modifier = Modifier.onClick { onClose() }
//                    .color(sitePalette.textFieldTextColor.rgb), size = IconSize.XL)

            }
            CommonText("Home",
                paddingBottom = 5.px,
                color = sitePalette.textFieldTextColor.rgb,
                onClick = { ctx.router.navigateTo("/homepage") })

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween // spacing between icon and text
            ) {
                CommonText("Services",
                    color = sitePalette.textFieldTextColor.rgb,
                    onClick = { isServicesDropdownOpen = !isServicesDropdownOpen })
                FaPlus(
                    modifier = Modifier
                        .color(sitePalette.topBarMenuText.rgb)
                        .fontSize(12.px)
                        .transition(Transition.of(TransitionProperty.All, 300.ms))
                        .transform {
                            if (isServicesDropdownOpen) {
                                rotate(180.deg)
                            } else {
                                rotate(0.deg)
                            }
                        })
            }
            val servicesList = listOf(
                "Web Development" to "/web-services",
                "Mobile App Development" to "/mobile-services",
                "Dev Ops" to "/dev-operation",
                "UI/UX Design" to "/ui-services",
                "AI Development" to "/ai-services",
                "Chatbot Development" to "/chatbot-development"
            )

            val servicesDropdownHeight = (servicesList.size * 30).px

            // Services dropdown
            Column(
                modifier = Modifier
                    .gap(4.px)
                    .margin(topBottom = (-5).px)
                    .maxHeight(if (isServicesDropdownOpen) servicesDropdownHeight else 0.px)
                    .opacity(if (isServicesDropdownOpen) 1f else 0f)
                    .overflow(Overflow.Hidden)
                    .transition(Transition.of(TransitionProperty.All, 500.ms))
            ) {
                servicesList.forEach { (label, route) ->
                    FieldTitleTextNormalSimple(
                        text = label,
                        color = sitePalette.sideBarDropDown.rgb,
                        fontSize = 14.px,
                        onClick = { ctx.router.navigateTo(route) }
                    )
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween // spacing between icon and text
            ) {
                CommonText("Industries",
                    color = sitePalette.textFieldTextColor.rgb,
                    onClick = { isIndustriesDropdownOpen = !isIndustriesDropdownOpen })
                FaPlus(
                    modifier = Modifier
                        .color(sitePalette.topBarMenuText.rgb)
                        .fontSize(12.px)
                        .transition(Transition.of(TransitionProperty.All, 300.ms))
                        .transform {
                            if (isIndustriesDropdownOpen) {
                                rotate(180.deg)
                            } else {
                                rotate(0.deg)
                            }
                        })
            }
            val industriesList = listOf(
                "Edu Industry" to "/industry-edu",
                "HealthCare Industry" to "/healthcare-system",
                "Fintech Industry" to "/fintech-Industry",
                "Sports Industry" to "/sports-industry"
            )

            val industriesDropdownHeight = (industriesList.size * 30).px

            // Industries dropdown
            Column(
                modifier = Modifier
                    .gap(8.px)
                    .margin(topBottom = (-5).px)
                    .maxHeight(if (isIndustriesDropdownOpen) industriesDropdownHeight else 0.px)
                    .opacity(if (isIndustriesDropdownOpen) 1f else 0f)
                    .overflow(Overflow.Hidden)
                    .transition(Transition.of(TransitionProperty.All, 500.ms))
            ) {
                industriesList.forEach { (label, route) ->
                    FieldTitleTextNormalSimple(
                        text = label,
                        color = sitePalette.sideBarDropDown.rgb,
                        fontSize = 14.px,
                        onClick = { ctx.router.navigateTo(route) }
                    )
                }
            }
            CommonText("Portfolio",
                paddingBottom = 5.px,
                color = sitePalette.textFieldTextColor.rgb,
                onClick = { ctx.router.navigateTo("/portfolio") })

            CommonText("Careers", color = sitePalette.textFieldTextColor.rgb,
                onClick = { ctx.router.navigateTo("/career-page") })
            CommonText("Blogs", color = sitePalette.textFieldTextColor.rgb,
                onClick = { ctx.router.navigateTo("/blogs") })
            if (showExtraText) {
                Row(
                    modifier = Modifier.padding(bottom = 5.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(6.px)
                ) {
                    FaPhone(
                        modifier = Modifier.color(sitePalette.commonSecondaryButtonColor.rgb),
                        size = IconSize.SM,
                    )
                    CommonText("+92-3057418989", color = sitePalette.textFieldTextColor.rgb)
                }
            }
            CommonButton(text = "CONTACT US", onClick = { ctx.router.navigateTo("/contact-us") }, letsTalkButton = true)
//        Box(
//            modifier = Modifier.width(152.px)
//                .height(43.px)
//                .backgroundImage(
//                    linearGradient(LinearGradient.Direction.ToRight,  rgba(97, 218, 187, 1), rgba(14, 176, 167, 1))
//                )
//                .borderRadius(4.px, 18.px, 4.px, 23.px),
//            contentAlignment = Alignment.Center
//        ) {
//            Row(
//                modifier = Modifier.fillMaxWidth(),
//                verticalAlignment = Alignment.CenterVertically,
//                horizontalArrangement = Arrangement.SpaceEvenly
//            ) {
//                SpanText(
//                    "Contact Us",
//                    modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
//                        .onClick {  ctx.router.navigateTo("/contact-us") }
//                )
//                FaArrowRight(modifier = Modifier)
//            }
//        }

        }
    }
}


@Composable
fun BarsSotIcon(onClose: () -> Unit) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        verticalArrangement = Arrangement.spacedBy(6.px),
        modifier = Modifier.onClick { onClose() }
    ) {
        // First bar – full-width, left-aligned
        Box(
            Modifier.width(30.px).height(4.px)
                .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)
                .borderRadius(2.px)
        )
        // Second bar – shorter, right-aligned
        Box(
            Modifier.fillMaxWidth()
                .height(4.px)
                .padding(left = 10.px)
                .backgroundColor(Color.transparent),
        ) {
            Box(
                Modifier.align(Alignment.CenterEnd)
                    .width(20.px)
                    .height(4.px)
                    .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)
                    .borderRadius(2.px)
            )
        }
        // Third bar – shortest, right-aligned
        Box(
            Modifier.fillMaxWidth()
                .height(4.px)
                .padding(left = 18.px)
                .backgroundColor(Color.transparent),
        ) {
            Box(
                Modifier.align(Alignment.CenterEnd)
                    .width(12.px)
                    .height(4.px)
                    .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)
                    .borderRadius(2.px)
            )
        }
    }
}

